import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Switch,
} from '@material-ui/core';
import CheckBoxOutlineBlankRoundedIcon from '@material-ui/icons/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';

import useStyles from './styles';

function SwitchControl(props) {
  const classes = useStyles();
  const {
    events = {},
    error,
    helperText,
    label,
    name,
    onChange,
    settings = {},
    size,
    type,
    value,
  } = props;

  const isCheckbox = type === 'checkbox';
  const isCardCheckbox = isCheckbox && settings?.variant === 'card';
  const Control = isCheckbox ? Checkbox : Switch;

  const handleChange = ({ target: { checked } }) => {
    const target = {
      name,
      value: checked,
    };
    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  return (
    <FormControl
      className={isCardCheckbox ? classes.cardFormControl : ''}
      error={error}
    >
      <FormGroup>
        <FormControlLabel
          className={[
            error ? classes.error : '',
            classes.customLabel,
            isCardCheckbox ? classes.cardLabel : classes.inlineLabel,
            error && isCardCheckbox ? classes.cardLabelError : '',
          ].join(' ')}
          control={
            <Control
              checked={Boolean(value)}
              color="primary"
              name={name}
              size={size}
              onChange={handleChange}
              className={isCheckbox ? classes.customCheckbox : classes.customSwitch}
              {...(isCheckbox
                ? {
                  checkedIcon: <CheckBoxRoundedIcon className={
                    isCardCheckbox ? classes.cardIconChecked : classes.inlineIconChecked
                  } />,
                  icon: <CheckBoxOutlineBlankRoundedIcon className={
                    isCardCheckbox ? classes.cardIcon : classes.inlineIcon
                  } />,
                }
                : {})}
            />
          }
          helperText={helperText}
          label={label}
        />
        <FormHelperText
          children={helperText}
          className={isCardCheckbox ? classes.cardHelperText : ''}
        />
      </FormGroup>
    </FormControl>
  );
}

SwitchControl.defaultProps = {
  size: 'small',
  type: 'switch',
  value: false,
  onChange: () => { },
};

SwitchControl.propTypes = {
  events: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  name: PropTypes.string,
  settings: PropTypes.object,
  size: PropTypes.oneOf(['small', 'medium']),
  type: PropTypes.oneOf(['checkbox', 'switch']),
  value: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SwitchControl;
